import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { createAction } from '../../../utils';
import ContentSections from '../../../components/base/ContentSections';
import MembershipInfoCard from '../../../components/customer/MembershipInfoCard';
import AuthButton from '../../../components/base/AuthButton';
import { PermissionCodes } from '../../../config/PermissionCodes';

function AdminDetail() {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();

  const { admin } = useSelector((state) => ({
    admin: state.admin.oneAdmin || {},
  }));

  const getSections = () => {
    let sections = [
      <MembershipInfoCard
        title={'General'}
        data={admin}
        fields={[
          [{ title: 'Name', field: 'username' }],
          [{ title: 'Password', field: 'displayPassword' }],
        ]}
      />,
      <MembershipInfoCard
        title={'Personal Information'}
        data={admin}
        fields={[
          [{ title: 'First name', field: 'firstName' }],
          [{ title: 'Last name', field: 'lastName' }],
          [{ title: 'Email address', field: 'email' }],
        ]}
      />,
      <MembershipInfoCard
        title={'Status'}
        data={admin}
        fields={[
          [{ title: 'Active', field: 'displayActive' }],
          [{ title: 'Superadmin status', field: 'displayIsSuper' }],
        ]}
      />,
      <MembershipInfoCard
        title={'Important dates'}
        data={admin}
        fields={[
          [{ title: 'Last login', field: 'displayLastLogin' }],
          [{ title: 'Date joined', field: 'displayDateJoined' }],
        ]}
      />,
    ];

    if (!admin.isSuperuser) {
      sections.splice(
        3,
        0,
        <MembershipInfoCard
          title={'Permission'}
          data={admin}
          fields={[
            [{ title: 'Administrator groups', field: 'displayGroups' }],
            [
              {
                title: 'Administrator permission',
                field: 'displayPermissions',
              },
            ],
          ]}
        />,
      );
    }

    return sections;
  };

  const tabs = [
    {
      name: 'Detail',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            sections={getSections()}
            hidePreview={true}
            // sectionStyle="detail-info-section-item"
          />
        </div>
      ),
    },
  ];

  const buttons = [
    <AuthButton
      title="Edit"
      action={() => {
        dispatch({ type: 'admin/clearData' });
        history.push({
          pathname: 'edit/',
        });
      }}
      requires={PermissionCodes.changeAdministrator}
    />,
  ];

  useEffect(() => {
    dispatch({ type: 'admin/clearData' });
  }, [dispatch]);

  useEffect(() => {
    const id = params.id;
    dispatch(createAction('admin/getOneAdmin')({ id, type: 'detail' }));
  }, [dispatch, params]);

  return (
    <div className="customer">
      <CustomListComponent
        caution={{
          detail: '',
          title: admin.name,
        }}
        defaultActiveKey={tabs[0].name}
        breadcrumb={<CustomBreadcrumb name={admin.name} />}
        buttons={buttons}
        tabs={tabs}
      />
    </div>
  );
}

export default AdminDetail;
